import React, { Component } from 'react';
import FormResa from './FormResa';

import { isEmpty } from 'lodash';
import PopUp from '../../../../commonModules/interface/PopUp';
import { TableRow, TableCell, TableBody, IconButton, Typography } from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../containers/Layout';
import { CloseRounded } from '@material-ui/icons';
import FormClient from '../sales/FormClient';
import { initClient, initErrorsResa, initResa } from '../StockFormsStruct';
import ProductLineCell from '../containers/ProductLineCell';
import { toast } from 'react-toastify';
import TransferAvailableStockToResa from '../resaDemands/TransferAvailableStockToResa';
import { generateUniqueId } from '../../../../commonModules/utils/statsFunctions';
import ConfirmFormTemplate from '../transfers/Forms/ConfirmFormTemplate';

class Form extends Component {
    state = { 
        newResa: Object.assign({},initResa),
        errors: Object.assign({},initErrorsResa),
        client: Object.assign({},initClient),
        errorsClient: Object.assign({},initClient),
        view: "resa",
        numberProd:1,
        sending: false,
        uniqueID: generateUniqueId(),
        form: <div></div>  // Liste des produits

    }
    
    componentDidMount = () => {
        const { PRODUCTS, SHOPS, oldRea } = this.props;
        if (!isEmpty(oldRea)) {

            let numberProd = oldRea.products.length
            let newResa = {
                shop_id: oldRea.shop_id,
                shop_idDisplay: {
                    label: SHOPS[oldRea.shop_id].name, 
                    value: oldRea.shop_id,
                },                
                natureDisplay:{value:"reservation", label:"Réservation"},
                nature:"reservation",
                total: oldRea.total,
                resa_demand_id: oldRea.id,
                resa_creator: oldRea.user_id,
                products: [],
            }
            let errors = Object.assign({}, this.state.errors)

            if( PRODUCTS ){
                Object.values(oldRea.products).forEach( (product, i) => {   
                    let prodInfo = PRODUCTS[product.product_id]                    
                    newResa.products.push(
                        {
                            display: {
                                value: prodInfo.id, 
                                label:`${prodInfo.marque} - ${prodInfo.name}`, 
                                // disabled: false
                            } ,
                            product_id: prodInfo.id,
                            quantity: product.quantity,
                            resa_item_id: product.id
                        }
                    )
                    
                    errors.products[i] = {
                        product_id: "",
                        quantity: "",
                    }
                })
            }

            this.setState({
                numberProd,
                newResa,
                errors
            }, () => {
                // Met à jour la liste produit
                this.createAddForm()
            });
        } 
    }
    handleSelect = (option, name) => {
        console.log("SELECT HANDLE",{option, name});

        let value = option.value
        let displayName = name +'Display'
        if(name === "nature"){
            console.log("change nature");
            
            this.setState({
                ...this.state,
                newResa:{
                    ...this.state.newResa,
                    transport:0,
                    taxes:0,
                    [name]:value,
                    [displayName]:option
                }
            }, () => {
                // Met à jour la liste produit
                this.createAddForm()
            });
        } else if(name === "shop_id"){
            console.log("change shop_id");
            
            this.setState({
                ...this.state,
                newResa:{
                    ...this.state.newResa,
                    [name]:value,
                    [displayName]:option,
                    products:[ // reset products array to prevent stock errors
                        {
                            display:{value:"", label:""},
                            product_id:"",
                            quantity:"",
                            max:"",
                        }
                    ],
                },
                numberProd:1
            }, () => {
                // Met à jour la liste produit
                this.createAddForm()
            });
        } else {
            this.setState({
                ...this.state,
                newResa:{
                    ...this.state.newResa,
                    [name]:value,
                    [displayName]:option
                }
            }, () => {
                // Met à jour la liste produit
                this.createAddForm()
            });
        }        
    }
    handleSelectProducts = (option, index) => {
        console.log("SELECT HANDLE",{option, index});

        let value = option.value
        const shop_id = this.state.newResa.shop_id
        const max = this.findMax(value, shop_id)    

        let cpProducts = this.state.newResa.products
        cpProducts[index].product_id = value
        cpProducts[index].max = max
        cpProducts[index].display = option
        
        this.setState({
            ...this.state,
            newResa:{
                ...this.state.newResa,
                products:cpProducts,
            }
        }, () => {
            // Met à jour la liste produit
            this.createAddForm()
        });        
    }

    findMax = (product_id, shop_id, list = this.props.AVAILABLE) => { // return available stock and it's id
        let max = 0

        Object.values(list).map( stock => {            
            if(stock.product_id === product_id  && stock.shop_id === shop_id ){    
                max = stock.quantity
                return                    
            }
        })   
        return max
    }
  
    createProductList = () => {
        const  { AVAILABLE, PRODUCTS } = this.props
        const { newResa } = this.state;
        const list = [{value: "", label: "Chosissez un Produit"}]

        if(AVAILABLE){
            let selectedProds = newResa.products.map( prod => prod.product_id)

            Object.values(AVAILABLE).map( stock => {   
                // Un produit désactivé n'est plus proposé au choix, même s'il
                // en reste en stock. Sa fiche reste dans le store : une
                // réservation existante qui le cite continue de s'afficher.
                if (PRODUCTS[ stock.product_id ] && PRODUCTS[ stock.product_id ].is_disabled) return
                let selected = selectedProds.includes(stock.product_id)
                if(stock.shop_id === newResa.shop_id && stock.quantity > 0){
                    list.push ({
                        value: stock.product_id, 
                        label: `${PRODUCTS[ stock.product_id ].marque} - ${PRODUCTS[ stock.product_id ].name} — ${PRODUCTS[ stock.product_id ].ref}`, 
                        disabled: selected
                    })
                }
            })
        }
        return list
    }

    createAddForm = () => {
        const tab = []
        const products = this.createProductList()

        // console.log("[INFO] CREATE ADD FORM INDEX ");
        for (let i = 0; i < this.state.numberProd;i++) {
            
            tab.push(
                <TableRow key={i} >             
                    {/* <TableCell>
                        {this.state.numberProd > 1 &&
                        <IconButton type="button" className="delete-line" onClick={()=> this.handleDeleteProd(i)}>
                            <CloseRounded />
                        </IconButton>
                        }
                        <InputSelectMagasin
                            options={products}
                            value={this.state.newResa.products[i].display}
                            label="Produit"
                            placeholder="Selectionner un Produit"
                            onChange={option => this.handleSelectProducts(option,i)}
                            // isOptionDisabled={option => option.disabled === true}
                            error={this.state.errors.products[i].product_id}
                        />    
                    </TableCell> */}
                    <ProductLineCell
                        numberProd={this.state.numberProd}
                        handleDeleteProd={() => this.handleDeleteProd(i)}
                        options={products}
                        value={this.state.newResa.products[i].display}
                        onChange={option => this.handleSelectProducts(option,i)}
                        error={this.state.errors.products[i].product_id}
                        PRODUCTS={this.props.PRODUCTS}
                    />
                    <TableCell className="text-center" style={{width: "150px"}}>
                        <InputText 
                            type="number" 
                            min={1} 
                            max={this.state.newResa.products[i].max} 
                            step={10} 
                            className="form-control input-sm" 
                            onChange={this.handleChange} 
                            value={this.state.newResa.products[i].quantity} 
                            name={"prod_-quantity-"+i} 
                            title="Quantité"
                            error={this.state.errors.products[i].quantity}
                            helperText={this.state.newResa.products[i].max ? "Disponible : "+ this.state.newResa.products[i].max :"" }
                        />
                    </TableCell>
                </TableRow>                                        
            )
        }
        this.setState({
            ...this.state,
            form:tab,
        })
        return tab;
    }
    handleAddProd = () => {// must add new line in the form to add a product to the resa
        this.setState({
            ...this.state,
            newResa:{
                ...this.state.newResa,
                products:[
                    ...this.state.newResa.products,{
                    display:{},
                    product_id:"",
                    quantity:"",
                    max:"",
                }]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products,{                      
                    product_id:"",
                    quantity:"",                    
                }]
            },
            numberProd:this.state.numberProd+1,
            
        }, () => {
            // Met à jour la liste produit
            this.createAddForm()
        });   
    }
    handleDeleteProd = (index) => {
        let cpProducts = [].concat(this.state.newResa.products)
        let cpErrors = [].concat(this.state.errors.products)
        // let total = 0;

        cpProducts = [
            ...cpProducts.slice(0,index),
            ...cpProducts.slice(index +1),
        ]
        cpErrors = [
            ...cpErrors.slice(0,index),
            ...cpErrors.slice(index +1),
        ]
        // cpProducts.map( prod => {
        //     if ( prod.priceR && prod.quantity && prod.priceTotal){
        //         total += parseFloat(prod.priceTotal)
        //     }
        // }) 
        this.setState({
            ...this.state,
            newResa:{
                ...this.state.newResa,
                products: cpProducts,
                // total,
            },
            errors:{
                ...this.state.errors,
                products: cpErrors
            },
            numberProd: this.state.numberProd - 1,
        }, () => {
            // Met à jour la liste produit
            this.createAddForm()
        });   
    }
    handleChange = (e) => {  
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        
        if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" || "prod_-product_id-4"

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            let cpProducts = [].concat(this.state.newResa.products)
            cpProducts[index][name] = value
            if(name === "quantity") {   
                if(value === "" || regex.test(value)){// update value only if its a int
                    this.setState({
                        ...this.state,
                        newResa:{
                            ...this.state.newResa,
                            products:cpProducts,
                        }
                    }, () => {
                        // Met à jour la liste produit
                        this.createAddForm()
                    });
                }
                
            } else {
                this.setState({
                    ...this.state,
                    newResa:{
                        ...this.state.newResa,
                        products:cpProducts,
                    }
                }, () => {
                    // Met à jour la liste produit
                    this.createAddForm()
                });
            }
                    
        } else {
            this.setState({
                ...this.state,
                newResa:{
                    ...this.state.newResa,
                    [field]:value
                }
            }, () => {
                // Met à jour la liste produit
                this.createAddForm()
            });
        }
    }
    handleChangeDate = (selectedDate) => {
        console.log("IN HANDLE CHANGE date", selectedDate);
        
        this.setState({
            ...this.state,
            newResa:{
                ...this.state.newResa,
                usage_date: selectedDate,

            }
        }, () => {
            // Met à jour la liste produit
            this.createAddForm()
        });
    }
    validate = () => {
        let noErrors = true
        let errors = this.state.errors
        // const notRequired = ["cli_type", "cli_typeDisplay", "usage_date"]
        // const notRequired = ["comments", "client_ref", "sale_paygo_id"]
        const notRequiredProdItem = ["max"]

        const resa = Object.assign({}, this.state.newResa)
        Object.keys(resa).map( field => {
            console.log(field);
            
            // if( isEmpty(resa[field]) && !notRequired.includes(field) ) {// input is empty  
            //     noErrors = false
            //     errors[field] = "Veuillez remplir ce champ"
                    
            // } else 
            if(field === "products") {
                resa.products.map((item, j) => {
                    Object.keys(item).map( field2 => { // field2 product_id || quantity
                        
                        if(notRequiredProdItem.includes(field2)){
                            errors.products[j][field2] = ""
                        } else if(item[field2] === "" || item[field2] === 0 || item[field2] === "0"){
                            noErrors = false
                            errors.products[j][field2] = "Veuillez remplir ce champ"
                        } else if(parseInt(item.max) < parseInt(item.quantity)){
                            noErrors = false
                            errors.products[j].quantity = "Stock insuffisant"
                        } else {
                            errors.products[j][field2] = ""
                        }
                    })
                })

            } else {// not empty
                errors[field] = ""   
            }
        })
                
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            ...this.state,
            errors : errors
        }, () => {
            // Met à jour la liste produit
            this.createAddForm()
        });
        if(noErrors){
            this.setState({
                view : "confirm"
                // view : "client"
            })
        } else {// !VALIDATE
            toast.error( "Le formulaire contient des erreurs")
        }
        
        // return noErrors
    }

    handleSubmit = async () => {

        this.setState({
            sending: true,
        })
        let resa = Object.assign({}, this.state.newResa)
        // let client = Object.assign({}, this.state.client)

        resa.date = new Date()
        resa.unique_id = this.state.uniqueID
        resa.nature = "reservation"
        // resa.shop_id = resa.shop
        // resa.client = client
        // resa.sale_paygo_id = resa.cli_type === "mjb" ? client.id : ""
        // resa.client_ref = resa.cli_type !== "mjb" ? client.id : ""

        for (let i = 0; i < resa.products.length; i++){
            resa.products[i].quantity = parseInt(resa.products[i].quantity)                      
        }
            
        // await this.props.makeResa(resa)
        try{
            await this.props.createNewResa(resa)
            this.setState({
                sending: false,
            })
            toast.info("Reservation enregistrée avec succès")
            this.props.closeSubmit ? this.props.closeSubmit() : this.props.handleClose()
      
        }catch(err){
            console.log("ERROR", err.message);
            this.setState({
                sending: false,
            })
            toast.error("[ERROR]"+err.message)
        }              
    }
    
    render() {
        const { view, newResa, client } = this.state;
        const { PRODUCTS} = this.props;
        console.log("[STATE] NEW RESAS FORM ",this.state.newResa);
        console.log("[PROPS] OLD RESA ",this.props.oldRea);

        const fieldList = [
            {name: "shop_id", label:"Magasin", display: newResa.shop_idDisplay.label},
            {name: "products"}, 
            {name: "totalArt"},  
        ]
    
        return (
            <React.Fragment>
                {view === "resa" &&
                    <div>
                        <TransferAvailableStockToResa 
                            {...this.state} 
                            {...this.props} 
                            handleSelect={this.handleSelect}
                            createAddForm={this.state.form}
                            handleAddProd={this.handleAddProd}
                            handleChange={this.handleChange}
                            handleAddProdByCSV={this.handleAddProdByCSV}
                            handleChangeDate={this.handleChangeDate}
                            validate={this.validate}
                            handleClose={this.props.handleClose}
                        />
                    </div>
                }
                
                {view === "confirm" &&
                <PopUp 
                    title="Résumé" 
                    close={() => this.setState({view: "resa"})}
                    submitAction={ this.handleSubmit }
                    submitTitle="Valider" 
                    disabledSubmit={this.props.STATE.resas.fetching || this.state.sending}
                    maxWidth="md"
                >
                    <TableLayout>
                        <TableBody>
                            <ConfirmFormTemplate
                                fieldList={fieldList}
                                transfer={this.state.newResa}
                                client={this.state.client}
                            />
                        </TableBody>
                    </TableLayout>
                </PopUp>
                }
            </React.Fragment>
        );
    }
}

export default Form;
